import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListingFilterConfig } from '../interfaces/listing.interface';

@Component({
  selector: 'app-listing-filters',
  templateUrl: './listing-filters.component.html',
  styleUrls: ['./listing-filters.component.scss']
})
export class ListingFiltersComponent {
  @Input() filters: ListingFilterConfig[] = [];
  @Input() isLoading: boolean = false;
  @Input() hasActiveFilters: boolean = false;
  
  @Output() filterChange = new EventEmitter<{ key: string; value: any }>();
  @Output() search = new EventEmitter<void>();
  @Output() clearFilters = new EventEmitter<void>();

  onFilterChange(key: string, value: any): void {
    this.filterChange.emit({ key, value });
  }

  onSearch(): void {
    this.search.emit();
  }

  onClearFilters(): void {
    this.clearFilters.emit();
  }
}
